export const FETCH_DEALERSHIPS_REQUEST = 'FETCH_DEALERSHIPS_REQUEST';
export const FETCH_DEALERSHIPS_SUCCESS = 'FETCH_DEALERSHIPS_SUCCESS';
export const FETCH_DEALERSHIPS_FAILURE = 'FETCH_DEALERSHIPS_FAILURE';
